import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContentListComponent } from "./pages/content-list/content-list.component";
import { CourseInventoryComponent } from "./pages/course-inventory/course-inventory.component";
import { LoginComponent } from "./pages/login/login.component";
import { AuthGuardService as AuthGuard } from './service/auth-guard.service';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { QaLinksComponent } from './pages/qa-links/qa-links.component';
import { CoursecompleteComponent } from './pages/coursecomplete/coursecomplete.component';
const routes: Routes = [

  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent,
    data: { title: 'LMS Login' }
  },
  {
    path: 'contents',
    component: ContentListComponent, canActivate: [AuthGuard],
    data: { title: 'LMS Contents' }
  },
  {
    path: 'qalinks',
    component: QaLinksComponent, canActivate: [AuthGuard],
    data: { title: 'QA Links' }
  },

  {
    path: 'courseinventory',
    component: CourseInventoryComponent, canActivate: [AuthGuard],
    data: { title: 'LMS Course Inventory' }
  },
  {
    path: '2870d8e87aa7413a9441aab26d8ca6e5',
    component: CoursecompleteComponent,
    data: { title: 'complete' }
  },

  {
    path: 'passwordreset/:hascode',
    component: ResetPasswordComponent,
    data: { title: 'Reset Password' }
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
